/**
 * «Bu 409 mening O'Z urinishimmi» — SOF mantiq, komponentdan ajratilgan.
 *
 * =====================================================================
 * ⛔ NEGA BU UMUMAN KERAK — O'LCHANGAN SHARTNOMA
 * =====================================================================
 * `POST /api/vouchers/activate` `Idempotency-Key` sarlavhasini UMUMAN
 * O'QIMAYDI: kontroller imzosida `@RequestHeader` yo'q, servis esa
 * grantni ikki argumentli `grants.issue(request, actor)` bilan beradi
 * (kalitli uchinchi argumentli variant BOSHQA metod). Ya'ni kalit
 * yuborilsa u JIMGINA tashlanardi va panelda «himoyalangan» degan
 * yolg'on tuyg'u qolardi.
 *
 * Takrorni to'sadigan narsa BOSHQA joyda va u kuchliroq: kartaning
 * o'zi. `VoucherServiceImpl.activate` shartli `UPDATE` qiladi
 * (`vouchers.activate(...)` `false` qaytarsa — rad) va holat
 * `ACTIVATED` bo'lgan karta `isActivatable()` dan o'tmaydi. Ya'ni
 * BITTA KOD BIR MARTA kuyadi, so'rov necha marta kelishidan qat'i
 * nazar. Idempotentlik kaliti — kodning O'ZI.
 *
 * =====================================================================
 * ⚠️ LEKIN BIR TESHIK QOLADI VA U KASSIRGA YOLG'ON AYTADI
 * =====================================================================
 * Tarmoq javob KELMASDAN uzilsa, kassir nima bo'lganini bilmaydi va
 * tugmani qayta bosadi. Server esa endi `409 VOUCHER_ACTIVATED`
 * qaytaradi — chunki BIRINCHI so'rov yetib borgan edi.
 *
 * Bu javobni «karta allaqachon ishlatilgan» deb ko'rsatish kassirni
 * mijozga NOTO'G'RI gap aytishga majbur qiladi: «kartangiz kuygan,
 * boshqasini oling». Aslida karta AYNAN SHU MIJOZGA, AYNAN SHU
 * loginga hozirgina ishlatilgan.
 *
 * Shuning uchun panel javobsiz qolgan urinishni ESLAB QOLADI va
 * keyingi `409` ni boshqa xabar bilan ko'rsatadi.
 *
 * ⚠️ Aniqlik chegarasi OCHIQ aytiladi (`vouchers.advice.OWN_RETRY`):
 * ayni kod + ayni login boshqa kassir tomonidan oradagi soniyalarda
 * ishlatilgan bo'lishi ham nazariy mumkin. Shuning uchun matn
 * «tekshiring» deydi, «bajarildi» demaydi.
 *
 * ⛔ MANTIQ ALOHIDA FAYLDA — `idempotencyHolder.ts` bilan bir xil
 * sabab: komponent ichida turganda uni faqat MATN bo'yicha tekshirish
 * mumkin bo'lardi va shart teskari yozilsa ham qorovul yashil qolardi.
 * Bu yerdagi funksiyalar qorovulda ROSTDAN chaqiriladi.
 */

/**
 * Urinishning bosqichi.
 *
 * `unanswered` — so'rov ketdi, javob KELMADI. Serverga yetgani
 *                NOMA'LUM, ya'ni karta kuygan ham bo'lishi mumkin.
 * `ownRetry`   — javobsiz urinishdan keyin server «bu karta
 *                ishlatilgan» dedi. Ya'ni birinchi so'rov yetib borgan.
 *                Bosqich SAQLANADI: kassir uchinchi marta bossa ham
 *                xabar O'ZGARMASLIGI kerak.
 */
export type AttemptPhase = 'unanswered' | 'ownRetry'

/** Faqat BITTA urinish eslab qolinadi — oxirgisi. */
export type AttemptLog = { seed: string; phase: AttemptPhase } | null

/**
 * Amal barmog'i — kod + login.
 *
 * ⚠️ IKKALASI HAM kiradi. Faqat kod bo'yicha eslab qolinsa, kassir
 * loginni tuzatib qayta yuborganda ham «bu mening urinishim» deb
 * ko'rsatilardi — holbuki karta BOSHQA loginga kuygan va aynan shu
 * farq muhim.
 */
export function attemptSeed(code: string, login: string): string {
  return `${code} ${login}`
}

/** Javob KELMADI — noaniqlik boshlandi. */
export function noteUnanswered(seed: string): AttemptLog {
  return { seed, phase: 'unanswered' }
}

/**
 * Server ANIQ javob berdi — noaniqlik tugadi.
 *
 * @param alreadyActivated javob aynan «karta ishlatilgan» (409
 *                         `VOUCHER_ACTIVATED`) bo'lsa
 */
export function noteAnswered(
  log: AttemptLog,
  seed: string,
  alreadyActivated: boolean,
): AttemptLog {
  if (alreadyActivated && looksLikeOwnRetry(log, seed)) {
    return { seed, phase: 'ownRetry' }
  }
  // ⚠️ Boshqa seed uchun ham `null`: eski urinishning izi yangi
  // kartaga o'tib ketmasin.
  return null
}

/** Shu (kod, login) juftligi uchun avval javobsiz urinish bo'lganmi. */
export function looksLikeOwnRetry(log: AttemptLog, seed: string): boolean {
  return log !== null && log.seed === seed
}
